import { StyledTagType } from 'ui-toolkit';

export enum eTitleSearchStatus {
  new = 'new',
  inProgress = 'in_progress',
  cancelled = 'cancelled',
  sent = 'sent',
  accepted = 'accepted',
}

export const prettyVendorStatus: Record<eTitleSearchStatus, string> = {
  [eTitleSearchStatus.new]: 'New',
  [eTitleSearchStatus.inProgress]: 'In Progress',
  [eTitleSearchStatus.cancelled]: 'Cancelled',
  [eTitleSearchStatus.sent]: 'Sent',
  [eTitleSearchStatus.accepted]: 'Accepted',
};

export const vendorStatusTagColor: Record<eTitleSearchStatus, StyledTagType> = {
  [eTitleSearchStatus.new]: 'green',
  [eTitleSearchStatus.inProgress]: 'yellow',
  [eTitleSearchStatus.cancelled]: 'gray',
  [eTitleSearchStatus.sent]: 'blue',
  [eTitleSearchStatus.accepted]: 'error',
};
export const activeStatuses = [eTitleSearchStatus.new, eTitleSearchStatus.inProgress, eTitleSearchStatus.sent];

export const allVendorStatuses = Object.values(eTitleSearchStatus);
export const vendorInitialStatuses = [
  eTitleSearchStatus.new,
  eTitleSearchStatus.inProgress,
  eTitleSearchStatus.cancelled,
  eTitleSearchStatus.sent,
];
